import { render } from "./footer.vue?vue&type=template&id=556f90bf&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=556f90bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-556f90bf"

export default script